@if (_osModel && _parsedValue !== undefined && _parsedValue !== null) {
    @if (
        _osModel.vtype !== ECpmCObjectStoreEntryProxyTypeApiEnum.OBJECT &&
        _osModel.vtype !== ECpmCObjectStoreEntryProxyTypeApiEnum.OBJECT_ARRAY
    ) {
        <span class="text">{{ _parsedValue }}</span>
    } @else {
        <p-button
            icon="pi pi-search"
            styleClass="underline"
            (onClick)="clickOnDetailsViewLink()"
            styleClass="p-0"
            label="View"
            link
        />
    }
} @else {
    <span class="text">--</span>
}
